// extracted by mini-css-extract-plugin
module.exports = {"spin":"Spin_spin__SDtSP","spinBlurOff":"Spin_spinBlurOff__yYA9U","spinHeader":"Spin_spinHeader__3ZJCM"};